<template>
  <div>
    <label>{{label || title}}</label>
    <div><a :href="val" target="__blank">{{val}}</a></div>
    <input type="file" :ref="get_file_field_name(name)">
    <div v-if="contentType == 'image'">
      <img :src="val" style="max-width: 300px;">
    </div>
  </div>
</template>

<script>
export default {
	props: [
		'name',
		'value',
		'label',
    'content-type',
    'title'
	],
  watch: {
    value() {
      this.setFileInputValue();
    }
  },
  methods: {
    get_file_field_name(name) {
      return "file_field_"+name;
    },
    get_file_field() {
      return this.$refs[this.get_file_field_name(this.name)];
    },
    setFileInputValue() {
      var val = _.get(this.value, this.name);
      if(val instanceof File) {
        var fileInput = this.get_file_field();
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(val);
        fileInput.files = dataTransfer.files;

        if (fileInput.webkitEntries.length) {
            fileInput.dataset.file = `${dataTransfer.files[0].name}`;
        }
      }
    }
  },
	computed: {
    val: {
      get () {
        let data = _.get(this.value, this.name)

        // Migrate 's3file' type field data for display
        if (typeof data === 'Object' || data instanceof Object) {
          data = _.get(data, "url", "")
        }

        return data
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  },
  mounted() {
    this.setFileInputValue();
  }
}
</script>
